module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av449-22cb7c4053c6fae047f5bcb8dd621fe2.jpg";